'use strict';

var gSTB = top.gSTB,
    apiSignature = (function () {
        var counter = 0,
            property;

        for ( property in gSTB ) {
            if ( gSTB.hasOwnProperty(property) ) {
                ++counter;
            }
        }

        return counter;
    })(),
    model            = gSTB.GetDeviceModelExt(),
    mac              = gSTB.GetDeviceMacAddress(),
    clientType       = 'STB',
    serialNumber     = gSTB.GetDeviceSerialNumber(),
    nativeApiVersion = gSTB.Version(),

    // HTTP request defaults
    defaults = {
        method: 'GET',
        async: true,
        headers: {},
        data: null,
        timeout: 30000,
        type: 'text',
        onload: function () {
            // callback when the request has successfully completed
        },
        onerror: function () {
            // callback when the request has failed
        },
        ontimeout: null
    },
    defaultsKeys = Object.keys(defaults),
    requestStack = [],
    locked = false,
    api = {
        host: null,
        authHost: null,
        lang: 'en',
        session: {
            accessToken: null,
            refreshToken: null,
            userId: null,
            macAlgorithm: null,
            macKey: null
        },
        auth: {
            login: function (credentials, callback) {
                var deviceId2 = Math.random().toString(36).substring(2),
                    client = fetch(),
                    random = Math.random().toString(36).substring(2),
                    ts = Math.round(Date.now() / 1000),
                    hash = gSTB.GetHashVersion1(random, ts),
                    hwVersion = hash + '.' + random + '.' + ts,
                    deviceId = gSTB.GetUID(),
                    postBody = [],
                    uid, loginData;

                console.log('hash ' + hash);
                if ( hash === 'false' ) {
                    setTimeout(function () {
                        api.auth.login(credentials, callback);
                    }, 5000);

                    return;
                }

                /* eslint no-fallthrough: 0 */
                switch ( model ) {
                    case 'AuraHD4':
                    case 'MAG322':
                    case 'MAG324':
                        deviceId = gSTB.GetUID('device_id', '1729452065727304', 3);

                        uid = gSTB.GetUID('device_id', deviceId2, 5);

                        deviceId2 = deviceId2 + '.' + uid;
                        if ( deviceId.length > 0 && uid.length > 0 ) {
                            break;
                        }

                    default:
                        deviceId = gSTB.GetUID();

                        uid = gSTB.GetUID('device_id', deviceId2);

                        if ( uid ) {
                            deviceId2 = deviceId2 + '.' + uid;
                        } else {
                            deviceId2 = '';
                        }
                        break;
                }

                /* eslint camelcase: 0 */
                loginData = {
                    grant_type: 'password',
                    client_type: clientType,
                    username: credentials.login,
                    password: credentials.password,
                    mac: mac,
                    serial_number: serialNumber,
                    stb_type: model,
                    model: model,
                    device_id: deviceId,
                    device_id2: deviceId2,
                    version: nativeApiVersion,
                    hw_version: hwVersion,
                    api_signature: apiSignature
                };

                Object.keys(loginData).forEach(function ( key ) {
                    postBody.push(key + '=' + encodeURIComponent(loginData[key]));
                });

                client.open('POST', api.authHost, true);

                client.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                client.timeout = 10000;

                client.onload = function () {
                    var data;

                    console.log('login responseText ' + this.responseText);
                    console.log('login status ' + this.status);
                    if ( this.status === 200 ) {
                        try {
                            data = JSON.parse(this.responseText);
                        } catch (error) {
                            console.log(error);
                            data = {};
                        }

                        if ( data.access_token && data.user_id ) {
                            api.session.accessToken = data.access_token;
                            api.session.refreshToken = data.refresh_token;
                            api.session.userId = data.user_id;

                            if ( data.mac_algorithm ) {
                                api.session.macAlgorithm = data.mac_algorithm;
                            }

                            if ( data.mac_key ) {
                                api.session.macKey = data.api.mac_key;
                                api.session.macAlgorithm = data.api.mac_algorithm;
                            }

                            if ( data.api && data.api.v3 ) {
                                api.session.macKey = data.api.v3.mac_key;
                                api.session.macAlgorithm = data.api.v3.mac_algorithm;
                            }

                            if ( api.saveCallback ) {
                                api.saveCallback();
                            }

                            callback(false);
                        } else {
                            callback(data, data);
                        }
                    } else {
                        callback(this.status + ' : ' + this.responseText, {});
                    }
                };

                client.ontimeout = function () {
                    callback('onerror ' + this.status + ' : ' + this.responseText, false);
                };

                client.onerror = function () {
                    callback('onerror ' + this.status + ' : ' + this.responseText, false);
                };

                console.log(postBody.join('&'));
                client.send(postBody.join('&'));
            },
            refreshToken: function (refreshToken, callback) {
                var client = fetch(),
                    random = Math.random().toString(36).substring(2),
                    ts = Math.round(Date.now() / 1000),
                    hash = gSTB.GetHashVersion1(random, ts),
                    hwVersion = hash + '.' + random + '.' + ts,
                    postBody = [],
                    refreshData;

                console.log('hash ' + hash);
                if ( hash === 'false' ) {
                    setTimeout(function () {
                        api.auth.refreshToken(refreshToken, callback);
                    }, 5000);

                    return;
                }

                refreshData = {
                    grant_type: 'refresh_token',
                    refresh_token: refreshToken,
                    hw_version: hwVersion,
                    model: model,
                    mac: mac,
                    client_type: clientType,
                    api_signature: apiSignature
                };

                Object.keys(refreshData).forEach(function ( key ) {
                    postBody.push(key + '=' + encodeURIComponent(refreshData[key]));
                });

                client.open('POST', api.authHost, true);

                client.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

                client.onload = function () {
                    var data;

                    console.log('refresh token status ' + this.status);
                    if ( this.status === 200 ) {
                        try {
                            data = JSON.parse(this.responseText);
                        } catch (error) {
                            data = {};
                            console.log(error);
                        }

                        console.log('refresh token responseText ' + this.responseText);
                        if ( data.access_token && data.user_id ) {
                            api.session.accessToken = data.access_token;
                            api.session.refreshToken = data.refresh_token;
                            api.session.userId = data.user_id;

                            if ( data.mac_algorithm ) {
                                api.session.macAlgorithm = data.mac_algorithm;
                            }

                            if ( data.mac_key ) {
                                api.session.macKey = data.api.mac_key;
                                api.session.macAlgorithm = data.api.mac_algorithm;
                            }

                            if ( data.api && data.api.v3 ) {
                                api.session.macKey = data.api.v3.mac_key;
                                api.session.macAlgorithm = data.api.v3.mac_algorithm;
                            }

                            if ( api.saveCallback ) {
                                api.saveCallback();
                            }

                            callback(false);
                        } else {
                            callback(data, data);
                        }
                    } else {
                        callback(this.status + ' : ' + this.responseText, {});
                    }
                };

                client.onerror = function () {
                    console.log('onerror');
                    callback(true, {});
                };

                console.log(postBody.join('&'));
                client.send(postBody.join('&'));
            }
        },
        /* eslint max-lines-per-function: 0 */
        /* eslint consistent-return: 0 */
        request: function (url, options) {
            var client = fetch(),
                eth0 = gSTB.GetLanLinkStatus(),
                wifi = gSTB.GetWifiLinkStatus(),
                userAgent = 'Model: ' + gSTB.GetDeviceModelExt() + '; Link: ',
                index, headersKeys;

            if ( locked ) {
                requestStack.push({
                    url: url,
                    options: options
                });

                return;
            }

            locked = true;
            // init
            options = options || {};

            // valid non-empty string
            if ( url && (typeof url === 'string' || url instanceof String) && url.length > 0 ) {
                // plain object is given as param
                if ( options && typeof options === 'object' ) {
                    // extend with default options
                    for ( index = 0; index < defaultsKeys.length; index++ ) {
                        // in case not redefined
                        if ( options[defaultsKeys[index]] === undefined) {
                            options[defaultsKeys[index]] = defaults[defaultsKeys[index]];
                        }
                    }
                }

                client = fetch();
                // init a request
                console.log(JSON.stringify([options.method, api.host + '/' + url, options.async]));
                client.open(options.method, api.host + '/' + url, options.async);

                client.setRequestHeader('Authorization', 'Bearer ' + api.session.accessToken);

                client.setRequestHeader('Content-Type', 'application/json');

                client.setRequestHeader('Accept-Language', api.lang);
                /* eslint no-nested-ternary: 0 */
                client.setRequestHeader('X-User-Agent', userAgent + (eth0 && wifi ? 'Ethernet,WiFi' : wifi ? 'WiFi' : eth0 ? 'Ethernet' : ''));

                // apply the given headers
                if ( options.headers && typeof options.headers === 'object' ) {
                    headersKeys = Object.keys(options.headers);
                    for ( index = 0; index < headersKeys.length; index++ ) {
                        client.setRequestHeader(headersKeys[index], options.headers[headersKeys[index]]);
                    }
                }

                // set response type and timeout
                client.responseType = options.type;
                client.timeout = options.timeout;

                client.onreadystatechange = function onreadystatechange () {
                    var data = false;

                    console.log(this.readyState);
                    console.log(this.status);
                    if ( this.readyState === 0 ) {
                        locked = false;
                        if ( requestStack.length > 0 ) {
                            data = requestStack.shift();
                            api.request(data.url, data.options);
                        }
                    } else if ( this.readyState === 4 ) {
                        try {
                            data = JSON.parse(this.responseText);
                        } catch (error) {
                            data = false;
                            console.log(error);
                        }

                        if ( this.status === 0 ) {
                            locked = false;
                            if ( requestStack.length > 0 ) {
                                data = requestStack.shift();
                                api.request(data.url, data.options);
                            }
                        } else if ( this.status === 200 ) {
                            try {
                                options.onload(!data, data);
                            } catch (error) {
                                if ( api.onfail ) {
                                    api.onfail('Exception thrown ' + error.message, error);
                                }
                                if ( options.onerror ) {
                                    try {
                                        options.onerror.call(client, error);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }
                            }

                            locked = false;
                            if ( requestStack.length > 0 ) {
                                data = requestStack.shift();
                                api.request(data.url, data.options);
                            }
                        } else if ( this.status === 401 ) {
                            if ( api.session.refreshToken ) {
                                api.auth.refreshToken(api.session.refreshToken, function (error) {
                                    if ( error ) {
                                        console.log(error);
                                        api.auth.login({
                                            password: '',
                                            login: ''
                                        }, function (error, result) {
                                            console.log(error);
                                            console.log(JSON.stringify(error));
                                            console.log(JSON.stringify(result));
                                            if ( error ) {
                                                if ( error.error === 'invalid_grant' ) {
                                                    api.oncredenitalsrequired(function () {
                                                        locked = false;
                                                        api.request(url, options);
                                                    });
                                                } else if ( error.error === 'access_denied' && error.error_description === 'Account disabled' ) {
                                                    api.oncredenitalsrequired(function () {
                                                        // empty callback
                                                    }, {
                                                        error: error
                                                    });
                                                } else {
                                                    locked = false;
                                                    api.request(url, options);
                                                }
                                            } else {
                                                locked = false;
                                                api.request(url, options);
                                            }
                                        });
                                    } else {
                                        locked = false;
                                        api.request(url, options);
                                    }
                                });
                            } else {
                                api.auth.login({
                                    password: '',
                                    login: ''
                                }, function (error, result) {
                                    console.log(JSON.stringify(error));
                                    console.log(JSON.stringify(result));
                                    if ( error ) {
                                        if ( error.error === 'invalid_grant' ) {
                                            api.oncredenitalsrequired(function () {
                                                locked = false;
                                                api.request(url, options);
                                            });
                                        } else if ( error.error === 'access_denied' && error.error_description === 'Account disabled' ) {
                                            api.reload();
                                            api.oncredenitalsrequired(function () {
                                                // empty callback
                                            }, {
                                                error: error
                                            });
                                        } else {
                                            locked = false;
                                            api.request(url, options);
                                        }
                                    } else {
                                        console.log(222);
                                        locked = false;
                                        api.request(url, options);
                                    }
                                });
                            }
                        } else if ( data && data.error === 'access_denied' && data.error_description === 'Account disabled' ) {
                            api.oncredenitalsrequired(function () {
                                // empty callback
                            }, {
                                error: data.error
                            });
                            locked = true;
                        } else {
                            locked = false;

                            try {
                                options.onload(this.status, this.responseText);
                            } catch (onloadException) {
                                console.log(onloadException);
                                //if ( api.onfail ) {
                                //    api.onfail('Exception thrown ' + e.message, e);
                                //}
                                if ( options.onerror) {
                                    try {
                                        options.onerror.call(client, onloadException);
                                    } catch (onerrorException) {
                                        console.log(onerrorException);
                                    }
                                }
                            }

                            if ( requestStack.length > 0 ) {
                                data = requestStack.shift();
                                api.request(data.url, data.options);
                            }
                        }
                    }
                };

                client.onerror = function () {
                    if ( options.onerror ) {
                        try {
                            options.onerror.call(client);
                        } catch (error) {
                            console.log(error);
                        }
                    }
                    if ( api.onfail ) {
                        api.onfail('Network error ' + client.status);
                    }
                };

                client.ontimeout = function () {
                    if ( options.ontimeout ) {
                        try {
                            options.ontimeout.call(client);
                        } catch (error) {
                            console.log(error);
                        }
                    }
                };

                // actual request
                client.send(options.body || null);

                return client;
            }
        }
    };


module.exports = api;
